import script from "./OverviewAmountOfTiresWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewAmountOfTiresWidget.vue?vue&type=script&setup=true&lang=js"

import "./OverviewAmountOfTiresWidget.vue?vue&type=style&index=0&id=0a36b19b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a36b19b"]])

export default __exports__